export class AuthUtils {
    constructor() {}

    static isTokenExpired(token: string): boolean {
        if (!token || token === '') {
            return true;
        }
    }
}
